import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import classNames from 'classnames';
import { BUTTON_STYLE, BUTTON_STYLE_COLLAPSE, LABEL_STYLE, LABEL_STYLE_COLLAPSE } from './style';
import HoverButton from '../../../buttons/HoverButton';

interface NavigationProps {
  id?: string;
  icon: JSX.Element;
  name: string;
  path: string;
  textClassName?: string;
  open?: boolean;
  state?: object;
}

export default function Navigation({
  id = '',
  icon,
  name,
  path,
  textClassName = '',
  open = false,
  state,
}: NavigationProps): JSX.Element {
  const location = useLocation();
  return (
    <HoverButton id={id} className="w-full" clickable={false}>
      <HoverButton.Button>
        <Link
          to={path}
          key={path}
          state={state}
          className={twMerge(
            BUTTON_STYLE,
            !open && BUTTON_STYLE_COLLAPSE,
            classNames({
              'bg-primary-300 hover:bg-opacity-100': location.pathname === path,
            }),
          )}>
          {icon}
          <p
            className={twMerge(
              LABEL_STYLE,
              !open && LABEL_STYLE_COLLAPSE,
              'font-semibold',
              textClassName,
            )}>
            {name}
          </p>
        </Link>
      </HoverButton.Button>
      {!open && (
        <HoverButton.Div className="transition-50 left-[150%] top-[50%] hidden -translate-y-[50%] rounded-[6px] bg-primary-900 px-3 py-2 group-[.collapsed]:block">
          <p className="whitespace-nowrap text-sm text-secondary-50">{name}</p>
          <div className="absolute -left-1 top-[50%] h-[15px] w-[15px] -translate-y-[50%] rotate-45 rounded-[2px] bg-primary-900" />
        </HoverButton.Div>
      )}
    </HoverButton>
  );
}
